import { ComponentProps, memo, ReactElement, ReactNode } from 'react'
import cn from 'classnames'

interface IProps extends ComponentProps<'div'> {
  children: ReactNode
  additional?: ReactNode
  className?: string
  closeButton?: ReactNode
  icon?: ReactElement
  isOrder?: boolean
  isShadow?: boolean
  isSticky?: boolean
  wrapperClassName?: string
}

export const ModalHeader = memo<IProps>(function ModalHeader({
  additional,
  children,
  className,
  wrapperClassName,
  closeButton,
  icon,
  isShadow,
  isSticky,
  isOrder,
  ...rest
}) {
  return (
    <div
      {...rest}
      className={cn('relative z-[1] min-h-[72px] text-wrap rounded-tl-xl rounded-tr-xl bg-surface', className, {
        'sticky top-0 z-[1000]': isSticky,
        'after:absolute after:-bottom-[3px] after:left-0 after:h-[3px] after:w-full after:select-none after:bg-[linear-gradient(to_bottom,rgb(26,28,30,0.12),transparent)] after:content-[""]':
          isSticky || isShadow
      })}
    >
      <div
        className={cn('px-6 py-5 text-headline-md text-on-surface/[.72]', wrapperClassName, {
          'pl-[80px]': !!icon,
          'pr-[64px]': !!closeButton,
          'p-4': !!isOrder
        })}
      >
        {icon && <div className="absolute left-6 top-3 flex size-[48px] items-center">{icon}</div>}
        {children}
      </div>
      {additional}
      {closeButton}
    </div>
  )
})
